import axios from '../API/axios';

export const emailQuote = (data: any) => {
  return axios.post('/emails/sendQuote', data);
}